// DS1.15M
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import { getDeviationTitle } from '../../DeviationViews/_helpers';
import { DeviationLink } from '../../Duperbrowse';
import UserAvatar from '../Avatar';
import UserLink from '../Link/UserLink';
import BasicUserName from '../BasicUserName';
import s from './UserIdentityLargeMobile.scss';
const UserIdentityLargeMobile = ({ user , deviation , className  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(Flex, {
        className: classnames(s['root'], className),
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: user,
        className: s['avatar'],
        size: 32
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['details']
    }, deviation && /*#__PURE__*/ React.createElement(DeviationLink, {
        deviation: deviation
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, getDeviationTitle(deviation)), user && /*#__PURE__*/ React.createElement("div", {
        className: s['userlink']
    }, t('user.identity.by'), /*#__PURE__*/ React.createElement(BasicUserName, {
        user: user
    }))), // We'll render the username as a link if the deviation wasn't provided
    // just to prevent any awkward blank space near the avatar in edge cases
    !deviation && user && /*#__PURE__*/ React.createElement(UserLink, {
        user: user
    })));
};
UserIdentityLargeMobile.displayName = 'UserIdentityLargeMobile';
export default UserIdentityLargeMobile;
